import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import { mapActions, mapState } from 'vuex'
// import dateUtils from '../../../../common/utils/dateUtil'
import moment from 'moment'

export default {
  data () {
    return {
      pageNum: 1,
      pageSize: 10,
      pageOrder: 'desc',
      pageSort: 'id',
      centerHeight: document.documentElement.clientHeight - 60 + 'px',
      points: '',
      grandTotalPoints: '',
      usePoints: '',
      type: '0'
    }
  },
  computed: {
    ...mapState('wxMemberModule', ['memberDetail']),
    memberDetailInfo () {
      return this.memberDetail
    }
  },
  methods: {
    ...mapActions('wxMemberModule', ['getMemberDetail']),
    dateFormat (time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    openCarDetails (id) {
      this.$router.push({
        path: RoutePathConstants.WX_PERSONAL_DETAIL,
        query: {
          id: id
        }
      })
    },
    goToMyCarServe (item) {
      this.$router.push({
        path: RoutePathConstants.MY_CAR_SERVE,
        query: {
          id: item.id,
          vehicleName: item.vehicleName
        }
      });
    },
    addAuthenticationCar () {
      this.$router.push({
        path: RoutePathConstants.ADD_MY_CAR
      })
    },
    openCarDetails (item) {
      this.$router.push({
        path: RoutePathConstants.ADD_MY_CAR,
        query: {
          item: JSON.stringify(item)
        }
      })
    }
  },
  mounted () {
    this.getMemberDetail()
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-car/views/my-car.js